import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import ActionButton from '@core/components/actionbutton/ActionButton';
import React from 'react';
import useExportPDF from 'hooks/use-export-pdf';
import { resumeTemplateList } from 'constants/resume-template-list.const';
import { myResumeService, exportMyResumeWithNewTemplates } from 'services/cv';
import { TickSquare } from 'iconsax-react';

import AvatarImage from 'assets/images/avatar-image.jpg';

import classes from './SelectPDFTemplate.module.scss';

const SelectPDFTemplate = ({ destroySelectTemplateModal }) => {
    const [selectedTempalteName, setSelectedTemplateName] = useState();
    const { exportResume, exportHtmlResume } = useExportPDF();
    const { data, isLoading } = useQuery(['user-resume-data-for-export'], () => myResumeService({ query: 'with_all_certificates=true' }));
    const { mutate } = useMutation(exportMyResumeWithNewTemplates.POST);
    const handleDownloadClick = () => {
        
        if (data && !isLoading) {
            // exportResume({ data:data.data , templateName: selectedTempalteName });

            mutate(selectedTempalteName);
            exportHtmlResume({ data: data.data, templateName: selectedTempalteName });
            destroySelectTemplateModal();
        }
    };
    return (
        <div className={classes['wrapper']}>
            <h2>Select a template</h2>
            <div className={classes['templates-wrapper']}>
                {resumeTemplateList.map((template) => (
                    <div
                        onClick={() => setSelectedTemplateName(template.name)}
                        className={selectedTempalteName === template.name ? classes['selected'] : ''}
                    >
                        <img src={template.image} />
                        {selectedTempalteName === template.name &&
                            <TickSquare size={38} color='#BB3A90' variant='Bold' />
                        }
                    </div>
                ))}
            </div>
            <div className='d-flex justify-content-end'>
                <ActionButton disabled={!selectedTempalteName} onClick={handleDownloadClick}>Select and Download</ActionButton>
            </div>

        </div>
    );
};

export default SelectPDFTemplate;